import type * as Yup from 'yup'

export const phoneRegExp = /^(\+?[1-9]{1,4}[ -]?)?(\([0-9]{2,3}\)[ -]?)?[0-9]{3,4}[ -]?[0-9]{3,4}[ -]?[0-9]{0,4}$/

export const passwordRequirementRegExp =
  // eslint-disable-next-line
  /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[ --*.!@#$%^&(){}[\]:;<>,.\\?\/~'"`_+=|])/

export const recoveryCodeRegExp = /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/

export type YupSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? Yup.StringSchema
    : T[K] extends number
    ? Yup.NumberSchema
    : T[K] extends Date
    ? Yup.DateSchema
    : T[K] extends boolean
    ? Yup.BooleanSchema
    : T[K] extends string[]
    ? Yup.ArraySchema<Yup.StringSchema>
    : T[K] extends object
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Yup.ObjectSchema<any>
    : // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Yup.SchemaOf<any>
}
